module.exports = __webpack_public_path__ + "static/img/machine.324c0ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/machine.png
// module id = na0U
// module chunks = 6